/*
  Cross-Sell como POPUP SOLO al añadir producto con recomendaciones
  - Solo aparece como popup cuando se añade un producto al carrito que tenga recomendaciones asociadas
  - NO se inserta en drawer, página de carrito, ni ficha de producto
  - Evita sugerir productos ya presentes en el carrito

  Configuración:
  - Definir window.CROSS_SELL = { handles: ['handle-1','handle-2','handle-3', ...] }
    (los handles se pueden facilitar más tarde; si se omite, usa recomendaciones nativas de Shopify)
*/
(function () {
  'use strict';

  var CONFIG = (window.CROSS_SELL || {});
  var HANDLES = Array.isArray(CONFIG.handles) ? CONFIG.handles.slice(0, 20) : [];
  var MAX_SUGERENCIAS = 3;

  // Cache de productos
  var cacheProducto = Object.create(null);
  var estilosInyectados = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function inyectarEstilos() {
    if (estilosInyectados) return;
    var css = [
      '.cross-sell{margin-top:16px;padding:12px;border:1px solid rgba(0,0,0,.08);border-radius:8px;background:#fafafa;} ',
      '.cross-sell__title{margin:0 0 12px 0;font-size:1rem;font-weight:600;} ',
      '.cross-sell__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;} ',
      '@media (max-width: 480px){.cross-sell__grid{grid-template-columns:repeat(2,minmax(0,1fr));}} ',
      '.cross-sell__card{display:flex;flex-direction:column;gap:8px;background:white;border:1px solid rgba(0,0,0,.06);border-radius:8px;overflow:hidden;} ',
      '.cross-sell__thumb{aspect-ratio:1/1;object-fit:cover;width:100%;height:auto;background:#f2f2f2;} ',
      '.cross-sell__name{font-size:.9rem;line-height:1.3;min-height:2.4em;} ',
      '.cross-sell__price{font-weight:600;} ',
      '.cross-sell__btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:8px 10px;border:1px solid #111;border-radius:6px;background:#111;color:#fff;font-size:.9rem;cursor:pointer;text-decoration:none;} ',
      '.cross-sell__btn[disabled]{opacity:.6;pointer-events:none;} ',
      /* Popup */
      '.cross-sell-modal{position:fixed;inset:0;display:none;align-items:center;justify-content:center;z-index:99999;} ',
      '.cross-sell-modal[aria-hidden="false"]{display:flex;} ',
      '.cross-sell-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.5);} ',
      '.cross-sell-modal__dialog{position:relative;max-width:940px;width:92vw;background:#fff;border-radius:10px;box-shadow:0 10px 30px rgba(0,0,0,.25);padding:18px;} ',
      '.cross-sell-modal__header{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;} ',
      '.cross-sell-modal__title{margin:0;font-size:1.05rem;font-weight:700;} ',
      '.cross-sell-modal__close{appearance:none;background:transparent;border:0;cursor:pointer;font-size:1.2rem;line-height:1;padding:4px;} ',
      '.cross-sell-modal__footer{display:flex;justify-content:flex-end;margin-top:12px;}',
      '.cross-sell__goto-cart{display:inline-flex;align-items:center;justify-content:center;padding:10px 14px;border:1px solid #111;border-radius:6px;background:#fff;color:#111;text-decoration:none;font-weight:600;}',
      '.cross-sell__goto-cart:hover{background:#111;color:#fff;}'
    ].join('');
    var style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    estilosInyectados = true;
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(Math.round(cents), (window.theme && window.theme.moneyFormat) || "€{{amount}}");
      }
    } catch (e) {}
    return (Math.max(0, Math.round(cents)) / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function fetchProductoPorHandle(handle) {
    if (cacheProducto[handle]) return Promise.resolve(cacheProducto[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return null;
        cacheProducto[handle] = data; // data.variants[0].price, images[0], title
        return data;
      })
      .catch(function () { return null; });
  }

  // Recomendaciones nativas por producto
  function fetchRecsPorProductoId(productId, intent, limit) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
              '&intent=' + encodeURIComponent(intent || 'complementary') +
              (limit ? ('&limit=' + encodeURIComponent(limit)) : '');
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) { return Array.isArray(data.products) ? data.products : []; })
      .catch(function () { return []; });
  }

  function normalizarPrecioProducto(prod) {
    // Soporta objetos de /products/{handle}.js y /recommendations/products.json
    if (prod && typeof prod.price === 'number') return prod.price;
    var v = (prod && prod.variants && prod.variants[0]) || null;
    return v && typeof v.price === 'number' ? v.price : 0;
  }

  function construirCard(prod) {
    var precio = normalizarPrecioProducto(prod);
    var url = (prod && prod.url) || (prod && prod.handle ? ('/products/' + prod.handle) : '#');
    var img = (prod && prod.images && prod.images[0]) || (prod && prod.featured_image) || '';

    var card = document.createElement('div');
    card.className = 'cross-sell__card';
    card.innerHTML = [
      img ? '<a href="' + url + '"><img class="cross-sell__thumb" loading="lazy" src="' + img + '" alt="' + (prod.title || '') + '"></a>' : '',
      '<div style="padding:10px;display:flex;flex-direction:column;gap:6px;">',
      '  <a class="cross-sell__name" href="' + url + '">' + (prod.title || '') + '</a>',
      '  <div class="cross-sell__price">' + formatMoney(precio) + '</div>',
      '  <button class="cross-sell__btn" data-handle="' + (prod.handle || '') + '">Añadir</button>',
      '</div>'
    ].join('');

    var btn = card.querySelector('.cross-sell__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.disabled = true;
        // Añadir el primer variant disponible
        var variantId = (prod && prod.variants && prod.variants[0] && prod.variants[0].id) || null;
        if (!variantId) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }).finally(function () {
            btn.disabled = false;
          });
      });
    }

    return card;
  }

  function ensureModal() {
    var modal = document.querySelector('.cross-sell-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cross-sell-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="cross-sell-modal__backdrop" data-close></div>',
      '<div class="cross-sell-modal__dialog">',
      '  <div class="cross-sell-modal__header">',
      '    <h3 class="cross-sell-modal__title">También te puede interesar</h3>',
      '    <button type="button" class="cross-sell-modal__close" aria-label="Cerrar" data-close>×</button>',
      '  </div>',
      '  <div class="cross-sell cross-sell--in-modal"><div class="cross-sell__grid"></div></div>',
      '  <div class="cross-sell-modal__footer">',
      '    <a href="/cart" class="cross-sell__goto-cart">Ir al carrito</a>',
      '  </div>',
      '</div>'
    ].join('');
    modal.addEventListener('click', function (e) { if (e.target && e.target.hasAttribute('data-close')) closeModal(); });
    document.body.appendChild(modal);
    return modal;
  }

  function openModalWithProducts(productos) {
    var modal = ensureModal();
    var grid = modal.querySelector('.cross-sell__grid');
    grid.innerHTML = '';
    productos.forEach(function (p) { grid.appendChild(construirCard(p)); });
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.querySelector('.cross-sell-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  // Función para verificar y mostrar popup solo cuando se añade un producto con recomendaciones
  function verificarYMostrarPopup(productId) {
    if (!productId) return;

    inyectarEstilos();

    // Obtener carrito actual para filtrar productos ya presentes
    fetchCart().then(function (cart) {
      var handlesEnCarrito = new Set((cart.items || []).map(function (it) { return it.handle; }));
      var precioReferencia = 0;
      (cart.items || []).forEach(function (it) { precioReferencia = Math.max(precioReferencia, (it.price || 0)); });

      function pintar(productos) {
        var candidatos = (productos || []).filter(Boolean).filter(function (p) { return !handlesEnCarrito.has(p.handle); });
        if (precioReferencia > 0) {
          candidatos.sort(function (a, b) {
            var da = Math.abs(normalizarPrecioProducto(a) - precioReferencia);
            var db = Math.abs(normalizarPrecioProducto(b) - precioReferencia);
            return da - db;
          });
        }
        var seleccion = candidatos.slice(0, MAX_SUGERENCIAS);
        if (!seleccion.length) return; // No hay recomendaciones, no mostrar popup

        // Solo mostrar popup si hay recomendaciones
        openModalWithProducts(seleccion);
      }

      // Si hay handles manuales, usarlos; si no, usar recomendaciones nativas del producto añadido
      if (HANDLES.length) {
        Promise.all(HANDLES.map(fetchProductoPorHandle)).then(pintar);
        return;
      }

      // Usar recomendaciones nativas del producto que se acaba de añadir
      fetchRecsPorProductoId(productId, 'complementary', 12).then(function (prods) {
        if (prods && prods.length) return pintar(prods);
        return fetchRecsPorProductoId(productId, 'related', 12).then(pintar);
      });
    }).catch(function () { /* silencio */ });
  }

  // Obtener product_id del último item añadido al carrito
  // Compara el carrito antes y después para identificar el producto añadido
  function obtenerProductIdAñadido(cartAnterior) {
    return fetchCart().then(function (cartNuevo) {
      if (!cartNuevo || !cartNuevo.items || cartNuevo.items.length === 0) return null;
      
      // Si no hay carrito anterior, tomar el último item
      if (!cartAnterior || !cartAnterior.items) {
        var ultimoItem = cartNuevo.items[cartNuevo.items.length - 1];
        return ultimoItem ? ultimoItem.product_id : null;
      }
      
      // Comparar items para encontrar el añadido
      var idsAnteriores = new Set((cartAnterior.items || []).map(function (it) { return it.variant_id; }));
      var itemAñadido = (cartNuevo.items || []).find(function (it) { return !idsAnteriores.has(it.variant_id); });
      
      return itemAñadido ? itemAñadido.product_id : null;
    }).catch(function () { return null; });
  }

  function bindObservers() {
    // Solo interceptar eventos de añadido al carrito, NO todos los eventos de actualización

    // Interceptar /cart/add con fetch
    if (!window.__crossSellFetchPatched) {
      var _fetch = window.fetch;
      try {
        window.fetch = function () {
          var url = arguments[0];
          var opts = arguments[1] || {};
          var isAdd = false;
          var cartAnteriorPromise = null;
          try {
            var href = (typeof url === 'string') ? url : (url && url.url) || '';
            isAdd = /\/cart\/(add|add.js)/.test(href) || (href === '/cart/add.js');
            // Guardar estado del carrito antes de añadir
            if (isAdd) {
              cartAnteriorPromise = fetchCart().catch(function () { return null; });
            }
          } catch (e) {}
          return _fetch.apply(this, arguments).then(function (resp) {
            if (isAdd && resp && resp.ok) {
              // Esperar un momento para que el carrito se actualice, luego obtener el product_id
              setTimeout(function () {
                Promise.resolve(cartAnteriorPromise).then(function (cartAnterior) {
                  return obtenerProductIdAñadido(cartAnterior);
                }).then(function (productId) {
                  if (productId) {
                    verificarYMostrarPopup(productId);
                  }
                });
              }, 300);
            }
            return resp;
          });
        };
        window.__crossSellFetchPatched = true;
      } catch (e) {}
    }

    // Interceptar XHR clásico
    if (!window.__crossSellXHRPatched && window.XMLHttpRequest) {
      var XHR = window.XMLHttpRequest;
      var open = XHR.prototype.open;
      var send = XHR.prototype.send;
      XHR.prototype.open = function (method, url) {
        this.__isAddReq = false;
        this.__cartAnteriorPromise = null;
        try {
          this.__isAddReq = /\/cart\/(add|add.js)/.test(String(url));
          // Guardar estado del carrito antes de añadir
          if (this.__isAddReq) {
            var self = this;
            this.__cartAnteriorPromise = fetchCart().catch(function () { return null; });
          }
        } catch (e) {}
        return open.apply(this, arguments);
      };
      XHR.prototype.send = function () {
        var self = this;
        var onReady = function () {
          if (self.__isAddReq && self.readyState === 4 && self.status >= 200 && self.status < 300) {
            // Esperar un momento para que el carrito se actualice, luego obtener el product_id
            setTimeout(function () {
              Promise.resolve(self.__cartAnteriorPromise).then(function (cartAnterior) {
                return obtenerProductIdAñadido(cartAnterior);
              }).then(function (productId) {
                if (productId) {
                  verificarYMostrarPopup(productId);
                }
              });
            }, 300);
          }
        };
        this.addEventListener('readystatechange', onReady);
        return send.apply(this, arguments);
      };
      window.__crossSellXHRPatched = true;
    }

    // También escuchar eventos específicos de añadido (si el theme los dispara)
    document.addEventListener('ajaxProduct:added', function (e) {
      var productId = (e.detail && e.detail.product_id) || null;
      if (productId) {
        setTimeout(function () {
          verificarYMostrarPopup(productId);
        }, 300);
      }
    });
  }

  function init() {
    inyectarEstilos();
    bindObservers();
    // Ya no hacemos refresh inicial, solo mostramos popup cuando se añade algo
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

